import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ordering',
  templateUrl: './ordering.component.html',
  styleUrls: ['./ordering.component.sass'],
})
export class OrderingComponent implements OnInit {
  @Input() param: string;
  @Input() currentParam: string;
  @Output() onOrderingClick = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {}

  orderingClick(event, direction) {
    event.preventDefault();
    let param = this.param;
    if (direction === 'desc') {
      param = '-' + param;
    }

    this.onOrderingClick.emit(param);
  }

  checkSelected(direction) {
    let param = this.param;
    if (direction === 'desc') {
      param = '-' + param;
    }
    return param === this.currentParam;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/ordering/ordering.component.ts